import getEnv from "@/utils/getEnv";
import { create } from "zustand";

type ReQueryParams = {
  url?: string;
  andLoading?: boolean;
  cacheBust?: boolean;
};

export type WhitelistData = {
  needScript: {id: string; name: string}[];
}; // 按需在调用处断言具体结构

const reQueryWhitelist = async () => {
  useWhitelistStore.setState({ isRequestingWhitelist: true, error: null });

  try {
    useWhitelistStore.setState({ isLoadingWhitelist: true });
    const response = await fetch(
      "https://headai-temp.s3.us-east-1.amazonaws.com/ads-white-list.json",
      {
        method: "GET",
        // mode: "cors",
        credentials: "omit",
        cache: "no-store",
        headers: {
          Accept: "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`请求白名单失败，状态码 ${response.status}`);
    }

    const data: WhitelistData = await response.json();
    useWhitelistStore.setState({
      whitelist: data,
      isLoadingWhitelist: false,
      isRequestingWhitelist: false,
      error: null,
    });
  } catch (err: any) {
    useWhitelistStore.setState({
      isRequestingWhitelist: false,
      isLoadingWhitelist: false,
      error: String(err?.message || err || "请求白名单异常"),
    });
  } finally {
    useWhitelistStore.setState({ isRequestingWhitelist: false });
  }
};

type WhitelistStore = {
  whitelist: WhitelistData;
  setWhitelist: (data: WhitelistData) => void;
  isLoadingWhitelist: boolean;
  setIsLoadingWhitelist: (loading: boolean) => void;
  isRequestingWhitelist: boolean;
  error: string | null;
  reQueryWhitelist: (params?: ReQueryParams) => Promise<void>;
};

export const useWhitelistStore = create<WhitelistStore>((set, get) => ({
  whitelist: { needScript: [] },
  setWhitelist: (whitelist) => set({ whitelist }),
  isLoadingWhitelist: false,
  setIsLoadingWhitelist: (isLoadingWhitelist) => set({ isLoadingWhitelist }),
  isRequestingWhitelist: false,
  error: null,
  reQueryWhitelist,
}));
